const HOUSE_NUMBER_OR_STREET_FIRST: "houseNumber" | "street" = window.SCHA.config.isHouseNumFirst
  ? "houseNumber"
  : "street";

export function createAddressLine1(houseNumber: string, street: string) {
  if (HOUSE_NUMBER_OR_STREET_FIRST === "houseNumber") {
    return houseNumber + " " + street;
  } else {
    return street + " " + houseNumber;
  }
}

export function splitAddressLine1(line: string) {
  const parts = line.split(" ");

  const houseNumber = (HOUSE_NUMBER_OR_STREET_FIRST === "houseNumber" ? parts.shift() : parts.pop()) ?? "";
  const street = parts.join(" ");

  return {
    street,
    houseNumber,
  };
}
